var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-simple-accordion",attrs:{"id":[_vm.modalId + '_simple-accordion_']}},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:(_vm.modalId),expression:"modalId"}],staticClass:"btn btn-link-plain",class:[_vm.icon]},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.title)}})]),_vm._v(" "),_c('b-collapse',{attrs:{"id":_vm.modalId,"visible":false}},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e90980b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/simple-accordion.vue
// module id = 365
// module chunks = 0 1